export default "__VITE_ASSET__B4lKip7G__"